import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import DataTable from "../interfaccia/DataTableBase";
import apiUrl from "../Apiurl";
import stilePulsanti from "../interfaccia/stilePulsanti";

function toInputDate(date) {
  return date.toISOString().slice(0, 10);
}

function getDefaultRange() {
  const today = new Date();
  const firstDayThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const firstDayPreviousMonth = new Date(
    firstDayThisMonth.getFullYear(),
    firstDayThisMonth.getMonth() - 1,
    1,
  );
  const lastDayPreviousMonth = new Date(
    firstDayThisMonth.getFullYear(),
    firstDayThisMonth.getMonth(),
    0,
  );

  return {
    dataStart: toInputDate(firstDayPreviousMonth),
    dataEnd: toInputDate(lastDayPreviousMonth),
  };
}

function formatImporto(value) {
  const number = Number(value || 0);
  return number.toLocaleString("it-IT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function formatIntero(value) {
  return Number(value || 0).toLocaleString("it-IT");
}

function buildParams({ dataStart, dataEnd, piattaforma, account }) {
  return {
    dataStart,
    dataEnd,
    piattaforma: piattaforma || undefined,
    account: piattaforma === "GESTIONALE" ? undefined : account || undefined,
  };
}

function formatDataItaliana(value) {
  if (!value) return "";
  const [anno, mese, giorno] = String(value).slice(0, 10).split("-");
  return giorno && mese && anno ? giorno + "/" + mese + "/" + anno : value;
}

function deduplicaCambiValuta(cambi) {
  const cambiPerDataValuta = new Map();
  (Array.isArray(cambi) ? cambi : []).forEach((cambio) => {
    const data = String(cambio.data || "").slice(0, 10);
    const valuta = String(cambio.valuta || "").trim().toUpperCase();
    if (!data || !valuta) return;
    const key = data + "|" + valuta;
    const precedente = cambiPerDataValuta.get(key);
    cambiPerDataValuta.set(key, {
      ...precedente,
      ...cambio,
      data,
      valuta,
      tassoCambio: cambio.tassoCambio ?? precedente?.tassoCambio ?? "",
    });
  });
  return Array.from(cambiPerDataValuta.values());
}

function ModalCambiValuta({ cambi, valori, onChange, onClose, onSave, saving }) {
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 z-999 flex items-center justify-center bg-black-50 pa3" onClick={onClose}>
      <div
        className="sfondoBiancoTema pa3 br2 shadow-4 w-90 w-50-l flex flex-column"
        style={{ maxHeight: "calc(100vh - 2rem)" }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex justify-between items-center mb3">
          <div>
            <div className="f4 b">Tassi di cambio</div>
            <div className="f6 colScrittaDef-20">Inserire il controvalore della valuta per EUR 1.</div>
          </div>
          <button className="dim tastoInputOrizzontale br3" type="button" onClick={onClose} disabled={saving}>CHIUDI</button>
        </div>
        <div className="bb bordoColAlt mb3" />
        <div className="overflow-auto pr2" style={{ minHeight: 0 }}>
          {cambi.map((cambio) => {
            const key = cambio.data + "|" + cambio.valuta;
            return (
              <div key={key} className="flex flex-wrap items-center mb2">
                <div className="w-30-ns w-100 mb1 mb0-ns">{formatDataItaliana(cambio.data)}</div>
                <div className="w-40-ns w-100 mb1 mb0-ns">EUR 1 = {cambio.valuta}</div>
                <input
                  className="inputOrizzontale w-30-ns w-100"
                  type="text"
                  inputMode="decimal"
                  placeholder="Es. 11,0145"
                  value={valori[key] ?? ""}
                  onChange={(event) => onChange(key, event.target.value)}
                />
              </div>
            );
          })}
        </div>
        <div className="flex justify-end mt3">
          <button className="tastoVerde white br2 ph2 pv1 flex justify-center items-center" type="button" onClick={onSave} disabled={saving}>
            <span className="material-symbols-outlined mr1">save</span>
            {saving ? "SALVO" : "SALVA CAMBI"}
          </button>
        </div>
      </div>
    </div>
  );
}

function ModalRigheRiepilogo({ riga, rows, loading, errore, onClose }) {
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 z-999 flex items-center justify-center bg-black-50 pa3" onClick={onClose}>
      <div className="sfondoBiancoTema pa3 br2 shadow-4 w-100 w-90-l" onClick={(event) => event.stopPropagation()}>
        <div className="flex justify-between items-center mb3">
          <div>
            <div className="f4 b">Righe confermate</div>
            <div className="f6 colScrittaDef-20">{formatDataItaliana(riga.data)} - {riga.isoCodeNazione} - {riga.valuta}</div>
          </div>
          <button className="dim tastoInputOrizzontale br3" type="button" onClick={onClose}>CHIUDI</button>
        </div>
        {errore && <div className="tastoRosso white pa2 br2 mb3">{errore}</div>}
        <div
          className="overflow-auto"
          style={{ maxHeight: "calc(100vh - 12rem)" }}
        >
          <table className="w-100 collapse">
            <thead><tr className="bb bordoColAlt tl"><th className="pa2">File controllo</th><th className="pa2">Controllo</th><th className="pa2">Tipo</th><th className="pa2">Riferimento ordine</th><th className="pa2 tr">Importo</th><th className="pa2">ID spedizione/rimborso</th></tr></thead>
            <tbody>
              {loading && <tr><td className="pa3 colScrittaDef-20" colSpan="6">Caricamento...</td></tr>}
              {!loading && rows.length === 0 && <tr><td className="pa3 colScrittaDef-20" colSpan="6">Nessuna riga confermata</td></tr>}
              {!loading && rows.map((row) => <tr key={row.idRiga} className="bb bordoColAlt"><td className="pa2">{row.nomeFile || "-"}</td><td className="pa2">{[row.piattaforma, row.account].filter(Boolean).join(" - ") || "-"}</td><td className="pa2">{row.tipoTransazione || "-"}</td><td className="pa2">{row.riferimentoOrdine || "-"}</td><td className="pa2 tr">{formatImporto(row.importo)} {row.valuta}</td><td className="pa2">{row.idSpedizioni || row.idRimborsi || "-"}</td></tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function RiepilogoCorrispettiviConfermati({ token }) {
  const defaultRange = useMemo(getDefaultRange, []);
  const [dataStart, setDataStart] = useState(defaultRange.dataStart);
  const [dataEnd, setDataEnd] = useState(defaultRange.dataEnd);
  const [piattaforma, setPiattaforma] = useState("");
  const [account, setAccount] = useState("");
  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [showCambi, setShowCambi] = useState(false);
  const [tassiCambio, setTassiCambio] = useState({});
  const [savingCambi, setSavingCambi] = useState(false);
  const [errore, setErrore] = useState("");
  const [rigaDettaglio, setRigaDettaglio] = useState(null);
  const [righeDettaglio, setRigheDettaglio] = useState([]);
  const [loadingDettaglio, setLoadingDettaglio] = useState(false);
  const [erroreDettaglio, setErroreDettaglio] = useState("");
  const cambiRichiestiUnivoci = useMemo(
    () => deduplicaCambiValuta(summary?.cambiRichiesti),
    [summary],
  );

  const validateRange = useCallback(() => {
    if (!dataStart || !dataEnd) {
      return "Seleziona data inizio e data fine";
    }
    if (dataStart > dataEnd) {
      return "La data fine deve essere successiva alla data inizio";
    }
    return "";
  }, [dataStart, dataEnd]);

  const loadData = useCallback(async () => {
    if (!token) {
      return;
    }
    const rangeError = validateRange();
    if (rangeError) {
      setErrore(rangeError);
      return;
    }

    setLoading(true);
    setErrore("");
    try {
      const response = await axios.get(
        apiUrl + "/contab/controlli-corrispettivi/riepilogo-giorno-paese",
        {
          headers: { Authorization: "Bearer " + token },
          params: buildParams({ dataStart, dataEnd, piattaforma, account }),
        },
      );
      setRows(response.data.data || []);
      setSummary(response.data.summary || null);
    } catch (error) {
      setErrore(
        error.response?.data?.error ||
          error.message ||
          "Errore caricamento riepilogo corrispettivi",
      );
    } finally {
      setLoading(false);
    }
  }, [account, dataEnd, dataStart, piattaforma, token, validateRange]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const exportCsv = async () => {
    if (!token) {
      return;
    }
    const rangeError = validateRange();
    if (rangeError) {
      setErrore(rangeError);
      return;
    }

    setExporting(true);
    setErrore("");
    try {
      const response = await axios.get(
        apiUrl + "/contab/controlli-corrispettivi/riepilogo-giorno-paese.csv",
        {
          headers: { Authorization: "Bearer " + token },
          params: buildParams({ dataStart, dataEnd, piattaforma, account }),
          responseType: "blob",
        },
      );
      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "riepilogo-corrispettivi-" + dataStart + "-" + dataEnd + ".csv";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      setErrore(
        error.response?.data?.error ||
          error.message ||
          "Errore esportazione CSV riepilogo corrispettivi",
      );
    } finally {
      setExporting(false);
    }
  };

  const apriCambi = () => {
    const valori = cambiRichiestiUnivoci.reduce((acc, cambio) => {
      acc[cambio.data + "|" + cambio.valuta] = cambio.tassoCambio ?? "";
      return acc;
    }, {});
    setTassiCambio(valori);
    setShowCambi(true);
  };

  const salvaCambi = async () => {
    const cambi = cambiRichiestiUnivoci;
    const mancanti = cambi.find((cambio) => !String(tassiCambio[cambio.data + "|" + cambio.valuta] ?? "").trim());
    if (mancanti) {
      setErrore("Inserisci il tasso " + mancanti.valuta + " del " + formatDataItaliana(mancanti.data));
      return;
    }
    setSavingCambi(true);
    setErrore("");
    try {
      await axios.post(apiUrl + "/contab/controlli-corrispettivi/cambi", {
        cambi: cambi.map((cambio) => ({
          data: cambio.data,
          valuta: cambio.valuta,
          tassoCambio: tassiCambio[cambio.data + "|" + cambio.valuta],
        })),
      }, { headers: { Authorization: "Bearer " + token } });
      setShowCambi(false);
      await loadData();
    } catch (error) {
      setErrore(error.response?.data?.error || error.message || "Errore salvataggio tassi di cambio");
    } finally {
      setSavingCambi(false);
    }
  };

  const resetFiltri = () => {
    setDataStart(defaultRange.dataStart);
    setDataEnd(defaultRange.dataEnd);
    setPiattaforma("");
    setAccount("");
  };

  const apriDettaglioRiga = useCallback(async (row) => {
    if (!token) return;
    setRigaDettaglio(row);
    setRigheDettaglio([]);
    setErroreDettaglio("");
    setLoadingDettaglio(true);
    try {
      const response = await axios.get(apiUrl + "/contab/controlli-corrispettivi/riepilogo-giorno-paese/righe", {
        headers: { Authorization: "Bearer " + token },
        params: { ...buildParams({ dataStart, dataEnd, piattaforma, account }), data: row.data, isoCodeNazione: row.isoCodeNazione, valuta: row.valuta },
      });
      setRigheDettaglio(response.data.data || []);
    } catch (error) {
      setErroreDettaglio(error.response?.data?.error || error.message || "Errore caricamento righe confermate");
    } finally {
      setLoadingDettaglio(false);
    }
  }, [account, dataEnd, dataStart, piattaforma, token]);

  const columns = useMemo(
    () => [
      {
        name: "",
        width: "55px",
        cell: (row) => (
          <button className="dim tastoInputOrizzontale br3" type="button" title="Mostra righe confermate" aria-label="Mostra righe confermate" onClick={() => apriDettaglioRiga(row)}>
            <span className="material-symbols-outlined">mystery</span>
          </button>
        ),
      },
      { name: "Data", selector: (row) => row.data, sortable: true, width: "115px" },
      { name: "ISO nazione", selector: (row) => row.isoCodeNazione, sortable: true, width: "125px" },
      {
        name: "Valuta", selector: (row) => row.valuta, sortable: true, width: "95px",
        cell: (row) => row.valuta === "EUR" ? <span>EUR</span> : <span className="tastoArancio ph2 pv1 br2 b">{row.valuta}</span>,
      },
      {
        name: "Cambio", selector: (row) => row.tassoCambio || 0, sortable: true, width: "145px",
        cell: (row) => row.valuta === "EUR" ? <span className="colScrittaDef-20">EUR</span> : row.cambioMancante ? <span className="tastoRosso white ph2 pv1 br2">Da inserire</span> : <span>1 EUR = {row.tassoCambio}</span>,
      },
      { name: "Entrate", selector: (row) => row.totaleImportiPositivi, sortable: true, right: true, width: "125px", cell: (row) => formatImporto(row.totaleImportiPositivi) },
      { name: "Rimborsi", selector: (row) => row.totaleImportiNegativi, sortable: true, right: true, width: "125px", cell: (row) => formatImporto(row.totaleImportiNegativi) },
      {
        name: "Netto EUR", selector: (row) => row.totaleNettoEur ?? 0, sortable: true, right: true, width: "135px",
        cell: (row) => row.cambioMancante ? <span className="colScrittaDef-20">-</span> : <span className={Number(row.totaleNettoEur) < 0 ? "tastoRosso white ph2 pv1 br2" : "b"}>{formatImporto(row.totaleNettoEur)}</span>,
      },
      { name: "Righe", selector: (row) => row.numeroRighe, sortable: true, right: true, width: "85px", cell: (row) => formatIntero(row.numeroRighe) },
      { name: "Vendite", selector: (row) => row.numeroVendite, sortable: true, right: true, width: "95px", cell: (row) => formatIntero(row.numeroVendite) },
      { name: "Refund", selector: (row) => row.numeroRimborsi, sortable: true, right: true, width: "95px", cell: (row) => formatIntero(row.numeroRimborsi) },
    ],
    [apriDettaglioRiga],
  );

  return (
    <div className="sfondoBiancoTema pa3">
      <div className="flex flex-wrap items-center justify-between bb bordoColAlt pb3 mb3">
        <div>
          <div className="f4 b">Riepilogo corrispettivi confermati</div>
          <div className="f6 colScrittaDef-20">
            Totali giornalieri per nazione dalle righe confermate
          </div>
        </div>
        <div className="flex items-center">
          {summary?.cambiRichiesti?.length > 0 && (
            <button className={summary.conversioneCompleta ? "tastoVerde white br2 ph2 pv1 mr2 flex justify-center items-center" : "tastoArancio br2 ph2 pv1 mr2 flex justify-center items-center"} type="button" onClick={apriCambi} disabled={loading}>
              <span className="material-symbols-outlined mr1">currency_exchange</span>
              Tassi di cambio
            </button>
          )}
          <button className={stilePulsanti.buttonClassesWhite} type="button" onClick={exportCsv} disabled={exporting || loading || rows.length < 1 || !summary?.conversioneCompleta} title={!summary?.conversioneCompleta ? "Inserire prima tutti i tassi di cambio" : "Scarica CSV in EUR"}>
            {exporting ? "Esporto..." : "Scarica CSV EUR"}
          </button>
        </div>
      </div>

      {errore && <div className="tastoRosso white pa3 br2 mb3">{errore}</div>}

      <div className="formRicercaOrizzontale pa2 flex flex-wrap justify-between items-center mb3">
        <div className="flex flex-wrap items-center">
          <div className="gruppoInputRicercaOrizzontale mr2 mb2">
            <input
              className="inputOrizzontale"
              type="date"
              title="Da data transazione"
              value={dataStart}
              onChange={(event) => setDataStart(event.target.value)}
            />
          </div>
          <div className="gruppoInputRicercaOrizzontale mr2 mb2">
            <input
              className="inputOrizzontale"
              type="date"
              title="A data transazione"
              value={dataEnd}
              onChange={(event) => setDataEnd(event.target.value)}
            />
          </div>
          <div className="gruppoInputRicercaOrizzontale mr2 mb2">
            <select
              className="inputOrizzontale"
              value={piattaforma}
              onChange={(event) => {
                setPiattaforma(event.target.value);
                if (event.target.value === "GESTIONALE") {
                  setAccount("");
                }
              }}
            >
              <option value="">Piattaforma: tutte</option>
              <option value="AMAZON">AMAZON</option>
              <option value="PRESTASHOP">PRESTASHOP</option>
              <option value="GESTIONALE">GESTIONALE</option>
            </select>
          </div>
          <div className="gruppoInputRicercaOrizzontale mr2 mb2">
            <input
              className="inputOrizzontale"
              type="text"
              placeholder="Account/fonte"
              value={account}
              disabled={piattaforma === "GESTIONALE"}
              onChange={(event) => setAccount(event.target.value)}
            />
          </div>
          <div className="gruppoInputRicercaOrizzontale mr2 mb2">
            <button
              className="dim tastoInputOrizzontale br3"
              type="button"
              onClick={loadData}
              disabled={loading}
            >
              {loading ? "CARICO" : "CERCA"}
            </button>
          </div>
          <div className="gruppoInputRicercaOrizzontale mr2 mb2">
            <button
              className="dim tastoInputOrizzontale br3"
              type="button"
              onClick={resetFiltri}
            >
              RESET
            </button>
          </div>
        </div>
        <div className="colScrittaDef-20 mb2">
          Righe {formatIntero(rows.length)}
        </div>
      </div>

      {summary && (
        <>
          {!summary.conversioneCompleta && (
            <div className="tastoArancio pa2 br2 mb3 flex items-center justify-between">
              <span>Ci sono {formatIntero(summary.cambiMancanti.length)} tassi di cambio da inserire prima dell'esportazione.</span>
              <button className="dim tastoInputOrizzontale br3" type="button" onClick={apriCambi}>INSERISCI CAMBI</button>
            </div>
          )}
          <div className="flex flex-wrap items-center mb3 bb bordoColAlt pb2">
            <div className="mr4 mb2"><div className="f7 ttu colScrittaDef-20">Entrate EUR</div><div className="f4 b">{summary.conversioneCompleta ? formatImporto(summary.totaleImportiPositiviEur) : "-"}</div></div>
            <div className="mr4 mb2"><div className="f7 ttu colScrittaDef-20">Rimborsi EUR</div><div className="f4 b">{summary.conversioneCompleta ? formatImporto(summary.totaleImportiNegativiEur) : "-"}</div></div>
            <div className="mr4 mb2"><div className="f7 ttu colScrittaDef-20">Netto EUR</div><div className="f4 b">{summary.conversioneCompleta ? formatImporto(summary.totaleNettoEur) : "-"}</div></div>
            <div className="mr4 mb2"><div className="f7 ttu colScrittaDef-20">Movimenti</div><div className="f4 b">{formatIntero(summary.numeroRighe)}</div></div>
            <div className="mr4 mb2"><div className="f7 ttu colScrittaDef-20">Vendite / Refund</div><div className="f4 b">{formatIntero(summary.numeroVendite)} / {formatIntero(summary.numeroRimborsi)}</div></div>
          </div>
        </>
      )}

      <DataTable
        columns={columns}
        data={rows}
        progressPending={loading}
        pagination
        paginationPerPage={50}
        paginationRowsPerPageOptions={[25, 50, 100, 200]}
        dense
        highlightOnHover
        noDataComponent={<div className="pa4 colScrittaDef-20">Nessun dato nel range selezionato</div>}
      />

      {rigaDettaglio && (
        <ModalRigheRiepilogo
          riga={rigaDettaglio}
          rows={righeDettaglio}
          loading={loadingDettaglio}
          errore={erroreDettaglio}
          onClose={() => !loadingDettaglio && setRigaDettaglio(null)}
        />
      )}
      {showCambi && (
        <ModalCambiValuta
          cambi={cambiRichiestiUnivoci}
          valori={tassiCambio}
          onChange={(key, value) => setTassiCambio((previous) => ({ ...previous, [key]: value }))}
          onClose={() => !savingCambi && setShowCambi(false)}
          onSave={salvaCambi}
          saving={savingCambi}
        />
      )}
    </div>
  );
}

export default RiepilogoCorrispettiviConfermati;
